import * as React from 'react';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
export type LoadingState = {
  isLoading?: boolean;
  setIsLoading?: any;
  loadPanelRef?: React.RefObject<LoadPanel>;
  setLoaderMessage?: (message?: string) => void;
};
const LoaderContext = React.createContext<LoadingState>({});

function LoaderProvider(props: any) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [loaderMessage, setLoaderMessage] = React.useState<string>(
    t('toast.loading')
  );
  const loadPanelRef = useRef<LoadPanel>(null);
  const handleLoaderMessage = React.useCallback((message?: string) => {
    setLoaderMessage(message ?? t('toast.loading'));
  }, []);
  const handleLoadinState = React.useCallback((value: boolean) => {
    if (value) {
      setCount((prev) => prev + 1);
    } else {
      setCount((prev) => (prev > 0 ? prev - 1 : 0));
    }
  }, []);

  React.useEffect(() => {
    setIsLoading(count > 0);
  }, [count]);
  return (
    <LoaderContext.Provider
      value={{
        isLoading,
        loadPanelRef,
        setIsLoading: handleLoadinState,
        setLoaderMessage: handleLoaderMessage,
      }}
    >
      {props.children}
      <LoadPanel
        ref={loadPanelRef}
        visible={isLoading}
        message={loaderMessage}
        showIndicator={true}
        shading={true}
        shadingColor="rgba(0,0,0,0)"
      />
    </LoaderContext.Provider>
  );
}

function useLoaderContext() {
  const context = React.useContext(LoaderContext);
  return context;
}

export { LoaderProvider, useLoaderContext };
